/**
 * Gestion du viewer POWER.xyz sur mobile
 * Ouvre la modale zoom sur le visuel cliqué (ou le visuel actuellement affiché) et y
 * défile, au lieu d'afficher systématiquement la première image.
 */
const PowerViewerMobile = {
  init: function (sectionId) {
    const isMobile = window.innerWidth <= 768;

    if (!isMobile) {
      return; // Ne pas activer sur desktop
    }

    document.addEventListener('click', function (e) {
      const isPowerViewerButton = e.target.closest(
        'power-viewer-switch, power-viewer-interaction-button, ' +
          'power-viewer-ar-button, .power-viewer-ar-button, ' +
          '.pv-toggle, .power-viewer-fullscreen',
      );

      if (isPowerViewerButton) {
        return; // Ne pas intercepter les clics sur les contrôles du viewer (AR, toggle, plein écran)
      }

      const mediaItem = e.target.closest(
        '.product__media-item, .product__modal-opener, [data-media-id]',
      );

      if (mediaItem) {
        e.preventDefault();
        e.stopPropagation();

        const modal = document.querySelector(`#ProductModal-${sectionId}`);
        if (modal) {
          // Ouvrir la modale
          modal.setAttribute('open', '');

          // Déterminer le visuel à afficher : le slide cliqué si identifiable, sinon le
          // slide actuellement visible dans la galerie (pas systématiquement le premier).
          let targetId = null;

          const clickedSlide = mediaItem.closest('.product__media-item');
          if (clickedSlide) {
            const toggle = clickedSlide.querySelector('.product__media-toggle[data-media-id]');
            if (toggle) targetId = toggle.getAttribute('data-media-id');
          }

          if (!targetId) {
            // ex. clic sur le picto zoom (hors slide) → slide le plus proche du scroll
            const viewer = document.querySelector(`#GalleryViewer-${sectionId}`);
            const slider = viewer && (viewer.querySelector('[id^="Slider-"]') || viewer);
            if (slider) {
              const slides = Array.from(
                slider.querySelectorAll('.product__media-item'),
              ).filter((s) => s.offsetWidth > 0);
              const x = slider.scrollLeft;
              const current = slides.reduce(
                (best, s) =>
                  best === null || Math.abs(s.offsetLeft - x) < Math.abs(best.offsetLeft - x)
                    ? s
                    : best,
                null,
              );
              const toggle =
                current && current.querySelector('.product__media-toggle[data-media-id]');
              if (toggle) targetId = toggle.getAttribute('data-media-id');
            }
          }

          let activeMedia = targetId
            ? modal.querySelector(`[data-media-id="${targetId}"]`)
            : null;
          if (!activeMedia) activeMedia = modal.querySelector('[data-media-id]'); // repli : 1er

          if (activeMedia) {
            modal
              .querySelectorAll('[data-media-id]')
              .forEach((el) => el.classList.remove('active'));
            activeMedia.classList.add('active');

            // Faire défiler la modale jusqu'au visuel actif (sinon elle reste affichée
            // sur la première image alors que la classe .active est posée ailleurs).
            requestAnimationFrame(function () {
              activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });
            });
          }
        }
      }
    });
  },
};

// Export pour utilisation globale
window.PowerViewerMobile = PowerViewerMobile;
